/* eslint-disable react-refresh/only-export-components */
import * as RdxDropdownMenu from '@radix-ui/react-dropdown-menu';
import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

interface IDropdownMenuContentProps {
  children: React.ReactNode;
  side?: 'right' | 'top' | 'bottom' | 'left';
  sideOffset?: number;
  align?: 'start' | 'center' | 'end' | undefined;
  alignOffset?: number;
}

interface IDropdownMenuItemProps {
  children: React.ReactNode;
  disabled?: boolean;
  className?: ClassValue;
  danger?: boolean;
  onClick?: () => void;
}

function DropdownMenuRoot({ children }: { children: React.ReactNode }) {
  return <RdxDropdownMenu.Root>{children}</RdxDropdownMenu.Root>;
}

function DropdownMenuTrigger({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: ClassValue;
}) {
  return (
    <RdxDropdownMenu.Trigger asChild className={cn(className)}>
      {children}
    </RdxDropdownMenu.Trigger>
  );
}

function DropdownMenuContent({
  children,
  side,
  sideOffset,
  align,
  alignOffset,
}: IDropdownMenuContentProps) {
  return (
    <RdxDropdownMenu.Portal>
      <RdxDropdownMenu.Content
        className="bg-surface-card border-border-default z-50 flex max-h-(--radix-dropdown-menu-content-available-height) flex-col gap-1 overflow-auto rounded-lg border p-2"
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
      >
        {children}
      </RdxDropdownMenu.Content>
    </RdxDropdownMenu.Portal>
  );
}

function DropdownMenuSeparator({ className }: { className?: ClassValue }) {
  return (
    <RdxDropdownMenu.Separator
      className={cn('bg-border-default mx-1 h-px', className)}
    />
  );
}

function DropdownMenuItem({
  children,
  disabled = false,
  onClick,
  className,
  danger,
}: IDropdownMenuItemProps) {
  return (
    <RdxDropdownMenu.Item
      disabled={disabled}
      className={cn(
        'bg-surface-card data-highlighted:bg-hover-subtle text-text-brand min-w-32 cursor-pointer rounded-lg p-2 outline-none data-disabled:opacity-40',
        danger && 'text-red-500 dark:text-red-400',
        className,
      )}
      onClick={onClick}
    >
      {children}
    </RdxDropdownMenu.Item>
  );
}

export const DropdownMenu = {
  Root: DropdownMenuRoot,
  Trigger: DropdownMenuTrigger,
  Content: DropdownMenuContent,
  Separator: DropdownMenuSeparator,
  Item: DropdownMenuItem,
};
